import { render, staticRenderFns } from "./TransparentLogo.vue?vue&type=template&id=84ec71ea&scoped=true"
import script from "./TransparentLogo.vue?vue&type=script&lang=js"
export * from "./TransparentLogo.vue?vue&type=script&lang=js"
import style0 from "./TransparentLogo.vue?vue&type=style&index=0&id=84ec71ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ec71ea",
  null
  
)

export default component.exports